import { Component, SimpleChanges, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ChartData, ChartOptions, ChartConfiguration } from 'chart.js';
import { environment } from '@portals/environments';
import { BaseComponent } from '@portals/core';
import { format } from 'date-fns';
import { finalize, tap } from 'rxjs';
import { CollectiblesState, AuthState, DashboardFilterData } from '@portals/store';

@Component({
	selector: 'portals-traffic',
	templateUrl: './traffic.component.html',
	styleUrls: ['./traffic.component.scss'],
})
export class TrafficComponent extends BaseComponent implements AfterViewInit {
	@Input() projectID!: number;
	@Input() currentFilters!: any;
	@Input() timeframe = 'monthly';
	@Output() responsesCountEmit = new EventEmitter<any>();
	public lineChartData: ChartData<'line'> = {
		datasets: [],
		labels: [],
	};
	ngOnChanges(changes: SimpleChanges) {
		if (changes['currentFilters']) {
			const previousValue = changes['currentFilters'].previousValue;
			const currentValue = changes['currentFilters'].currentValue;

			if (!this.isEqual(previousValue, currentValue)) {
				this.getChart(this.timeframe, currentValue);
				this.cdr.detectChanges();
			}
		}
	}
	private isEqual(obj1: any, obj2: any): boolean {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}
	constructor(private collectibles: CollectiblesState, private authState: AuthState, private cdr: ChangeDetectorRef) {
		super();
	}
	ngAfterViewInit() {
		this.getChart(this.timeframe, this.currentFilters);
	}

	public lineChartOptions: ChartOptions<'line'> = {
		responsive: true,
		maintainAspectRatio: false,
		elements: {
			point: {
				radius: 0,
				hitRadius: 10,
			},
		},
		scales: {
			x: {
				grid: {
					display: true,
				},
				ticks: {
					maxRotation: 0,
					minRotation: 0,
					autoSkip: true,
					maxTicksLimit: 10,
				},
			},
			y: {
				grid: {
					display: true,
				},
			},
		},
		plugins: {
			legend: {
				display: true,
				position: 'top',
				labels: {
					boxWidth: 10,
					boxHeight: 10,
					pointStyle: 'circle',
					usePointStyle: true,
				},
			},
		},
	};
	public lineChartLegend = true;
	public lineChartPlugins = [];
	timeframes = ['daily', 'weekly', 'monthly', 'yearly'];
	formLoading = false;
	app = environment.app;
	admin = false;
	dateInfo = new Date();
	totalCount = 0;
	desktopAppCount = 0;
	mobileWebCount = 0;
	appCount = 0;
	async getChart(timeframe: string, filter: any) {
		this.formLoading = true;
		this.subscribe(
			this.collectibles.getTrafficData(timeframe, this.projectID, filter).pipe(
				tap((data: any) => {
					this.series = [
						{
							data: [],
							label: 'Total',
						},
						{
							data: [],
							label: 'Desktop',
						},
						{
							data: [],
							label: 'Mobile Browser',
						},
						{
							data: [],
							label: 'App',
						},
					];
					this.date = [];
					let intTotalCount = 0;
					let intTotalDesk = 0;
					let intTotalMobileB = 0;
					let intTotalApp = 0;
					const alldata = data.deviceData;
					for (let i = 0; i < alldata.mobile.length; i++) {
						const desktopData = alldata['desktop_web'][i];
						const mobileWebData = alldata['mobile_web'][i];
						const appData = alldata['mobile'][i];
						const currentDeskCount = parseInt(desktopData['row_count']);
						const currentMobileCount = parseInt(mobileWebData['row_count']);
						const currentAppCount = parseInt(appData['row_count']);
						this.date.push(desktopData.date || new Date());
						const totalCountI = currentAppCount + currentMobileCount + currentDeskCount;
						this.series[0].data.push(totalCountI);
						this.series[1].data.push(currentDeskCount);
						this.series[2].data.push(currentMobileCount);
						this.series[3].data.push(currentAppCount);
						intTotalCount += totalCountI;
						intTotalDesk += currentDeskCount;
						intTotalMobileB += currentMobileCount;
						intTotalApp += currentAppCount;
					}
					this.totalCount = intTotalCount;
					this.desktopAppCount = intTotalDesk;
					this.mobileWebCount = intTotalMobileB;
					this.appCount = intTotalApp;
				}),
				finalize(() => {
					this.labels = this.date;
					const dataset = this.series.map((i: any) => {
						return { label: i.label, data: i.data, tension: 0.4 };
					});
					const dates = this.labels.map((i: any) => format(new Date(i), 'MMM dd'));

					this.lineChartData = {
						datasets: dataset,
						labels: dates,
					};
					this.formLoading = false;
				})
			)
		);
	}
	ngOnInit(): void {}
	changeTimeframe(event: any) {
		this.timeframe = event.target.value;
		this.getChart(this.timeframe, this.currentFilters);
	}
}
